export default __webpack_public_path__ + "static/about-us-img-ff7f12e160d3e974c96b95ebdc31fdcb.svg";